export default __webpack_public_path__ + "static/media/instagram.512b3c19.svg";